import Http from "./http";

export const getClaimDetailAPI = (data) => {
  return Http.post("admin/product/getClaimDetail", data);
};
